import { Skeleton, SkeletonBox } from "@hightouch/htui";

/** Stands in for media that hasn't loaded, sized like a square creative. */
export function MediaDetailMediaSkeleton() {
  return (
    <Skeleton isLoading>
      <SkeletonBox
        width="480px"
        maxWidth="100%"
        height="480px"
        maxHeight="100%"
        borderRadius="lg"
      />
    </Skeleton>
  );
}
